import { AlertTriangleIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

interface InstructionsTabWarningProps {
  show: boolean;
}

export function InstructionsTabWarning({ show }: InstructionsTabWarningProps) {
  const { t } = useTranslation();
  if (!show) {
    return null;
  }

  return (
    <AlertTriangleIcon
      data-test="instructions-mandatory-warning"
      className="ml-2 size-4 shrink-0 text-red-600 dark:text-red-400"
      aria-label={t("translation:task.detail.instructions.mandatory-warning")}
    />
  );
}
